import { render } from "./AllegatiUploader.vue?vue&type=template&id=bf2fa232&ts=true"
import script from "./AllegatiUploader.vue?vue&type=script&lang=ts"
export * from "./AllegatiUploader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__